export const REACT_PORT = "3000";
export const API_URL =
  window.location.port === REACT_PORT ? "https://localhost:8000/" : "/";
